import { render, staticRenderFns } from "./SupplementaryQuestions.vue?vue&type=template&id=07d5b164&scoped=true&"
import script from "./SupplementaryQuestions.vue?vue&type=script&lang=js&"
export * from "./SupplementaryQuestions.vue?vue&type=script&lang=js&"
import style0 from "./SupplementaryQuestions.vue?vue&type=style&index=0&id=07d5b164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d5b164",
  null
  
)

export default component.exports